export const TOAST_KIND = {
  primary: "primary",
  secondary: "secondary",
}
